<div class="flex flex-col justify-center items-center mt-6"
     [ngStyle]="movilFragment === 'movil' ? {'padding-left': '16px', 'padding-right': '16px'} : {}">
  <img width="128px" [src]="getIconPath()" />

  <h2 *ngIf="statusNotification === 'ko' || statusNotification === 'esim-ko' || statusNotification === 'revolu-ko' || statusNotification === 'docs-ko'" class="text-center font-semibold mb-0">
    Ooops!
  </h2>

  <h2 class="text-center font-semibold"
      [ngClass]="{ 'mt-0': !statusNotification.includes('ok') }">
    {{ getTitleKey('TITLE') | translate }}
  </h2>

  <p class="text-base text-center">{{ getTitleKey('DESC') | translate}}</p>

  <p *ngIf="statusNotification === 'ko' || statusNotification === 'revolu-ko' || statusNotification === 'docs-ko' || statusNotification === 'esim-ko'" class="mt-8 font-semibold text-xl">
    {{ 'CHECKOUT.KO.TRY' | translate }}
  </p>

  <app-button *ngIf="movilFragment !== 'movil' && movilFragment !== 'esim' && movilFragment !== 'revoluKyc' && movilFragment !== 'revoluPaylands'" class="mt-20" routerLink="/recharges">
    {{ 'CHECKOUT.BUTTON' | translate }}
  </app-button>

  <app-button *ngIf="movilFragment === 'esim'" class="mt-20" (click)="Redirect()">
    {{ 'CHECKOUT.BUTTON' | translate }}
  </app-button>

  <!--<app-button *ngIf="movilFragment === 'revoluKyc'" class="mt-20" routerLink="/transfers">-->
  <app-button *ngIf="movilFragment === 'revoluKyc'" class="mt-20" routerLink="self.close()">
    {{ 'CHECKOUT.BUTTON' | translate }}
  </app-button>

  <app-button *ngIf="movilFragment === 'movil' || movilFragment === 'revoluPaylands'" class="mt-20" (click)="close()">
    {{ 'CHECKOUT.BUTTON' | translate }}
  </app-button>
</div>
